import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import avatarVideo from "../../assets/avatares/mute-red.webm";
import avatarVideoMp4 from "../../assets/avatares/mute-red.mp4";
import manuelVideo from "../../assets/bg/silent-video-manuel.webm";
import manuelVideoMp4 from "../../assets/bg/silent-video-manuel.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario1Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.0
	});

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "50%",
								marginTop: "24px",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur h-100 px-5">
						<div className="recuadro-white txtTexto1 mb-3 w-100">
							<h3 className="txtTitulos txt-red mb-4">
								Presentación del caso clínico
							</h3>
							<p>Desde su diagnóstico en 2013, la vida de Juan ha sido compleja. Ha pasado por las siguientes líneas de tratamiento:</p>
							<strong>1ª línea (2013-2016):</strong>
							<p>Inició con VTd (4 ciclos), seguido de quimioterapia (2 ciclos) y un trasplante autólogo. Logró una respuesta parcial y se mantuvo con lenalidomida por unos 3 años, hasta su primera progresión en mayo de 2016.</p>
							<strong>2ª línea (2016-2017):</strong>
							<p>Recibió KRd por 12 ciclos, y alcanzó nuevamente una respuesta parcial. Continuó con mantenimiento por 6 meses, pero la enfermedad progresó en diciembre de 2017.</p>
							<strong>3ª línea (2017-2020):</strong>
							<p>Fue tratado con daratumumab-pomalidomida-dexametasona durante 32 ciclos, y logró mantener una respuesta parcial</p>
							<div className="notaCasoClinicoAutor">caso clínico del autor</div>
						</div>
						<NextButton
							navigateTo={ROUTES.SCENARIO1_INTRO2}
							activeScenario="1"
							color="red"
						/>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario1Intro);
